import { useState } from "react";
import { FieldDefaultFormula } from "./FieldDefaultFormula";
import { FieldTextPermissioned } from "components/FieldTextPermissioned/FieldTextPermissioned";

interface FieldDefaultFormulaTextProps {
  autoFocus?: boolean;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}

export const FieldDefaultFormulaText = ({
  autoFocus,
  value,
  onChange,
}: FieldDefaultFormulaTextProps) => {
  const [newFormula, setNewFormula] = useState(value ?? "");
  return (
    <FieldDefaultFormula>
      <FieldTextPermissioned
        requiredPermission="edit"
        fullWidth
        autoFocus={autoFocus}
        placeholder="None"
        value={newFormula}
        onChange={(e) => {
          const newValue = e.target.value;
          setNewFormula(newValue);
          // Coerce formula to a text value
          onChange(`'${newValue}`);
        }}
        maxLength={255}
      />
    </FieldDefaultFormula>
  );
};
